"use client"

import { ReactNode } from "react"
import { Button } from "@ui/shad"
import { AlertTriangle, X } from "lucide-react"

interface IntegrationBannerProps {
  title: string
  description?: ReactNode
  actionLabel?: string
  onAction?: () => void
  onDismiss: () => void
  isActionPending?: boolean
  actionPendingLabel?: string
}

export function IntegrationBanner({
  title,
  description,
  actionLabel,
  onAction,
  onDismiss,
  isActionPending,
  actionPendingLabel,
}: IntegrationBannerProps) {
  return (
    <div className="bg-yellow-background border-yellow-border flex items-center justify-between border-b px-4 py-2">
      <div className="flex items-center gap-3">
        <AlertTriangle className="text-yellow-accent h-4 w-4 flex-shrink-0" />
        <p className="text-sm">
          <span className="font-medium">{title}</span>
          {description && (
            <>
              {" "}
              <span className="text-muted-foreground">{description}</span>
            </>
          )}
        </p>
      </div>
      <div className="flex items-center gap-2">
        {actionLabel && onAction && (
          <Button size="sm" onClick={onAction} disabled={isActionPending}>
            {isActionPending ? (actionPendingLabel ?? "Redirecting...") : actionLabel}
          </Button>
        )}
        <Button variant="ghost" size="iconSm" onClick={onDismiss} aria-label="Dismiss">
          <X />
        </Button>
      </div>
    </div>
  )
}
